import { AxiosError } from 'axios'
import { useQuery, UseQueryOptions } from 'react-query'

import { filtersApi } from './filters.api'
import { FILTERS_PRIVATE_REQUESTS } from './filters.constants'
import { components } from '@plandi/common/src/generated'
import { useLocale } from '@plandi/common'

export const useQueryPrivateRequests = <
  T = components['schemas']['PrivateRequests'] | undefined
>(
  keyword: string | undefined,
  type: string | undefined,
  options?: UseQueryOptions<
    components['schemas']['PrivateRequests'] | undefined,
    AxiosError,
    T
  >
) => {
  const locale = useLocale()
  const data = useQuery(
    [FILTERS_PRIVATE_REQUESTS, keyword, type, locale],
    () => filtersApi.getPrivateRequests(keyword, type, locale),
    options
  )

  return data
}
